<div class="cart-widget-side">
  <div class="widget-heading">
    <h3 class="widget-title">Shopping cart</h3>
    <a class="widget-close" href="#" (click)="close(); $event.preventDefault()">Close</a>
  </div>
  <div class="widget woocommerce widget_shopping_cart">
    <div class="widget_shopping_cart_content">
      @if (isEmpty()) {
        <p class="woocommerce-mini-cart__empty-message empty">No products in the cart.</p>
      } @else {
        <ul class="cart_list product_list_widget woocommerce-mini-cart">
          @for (line of cart.items(); track line.id) {
            <li class="woocommerce-mini-cart-item mini_cart_item">
              <a class="remove" href="#" (click)="remove(line); $event.preventDefault()" aria-label="Remove"
                >&times;</a
              >
              <a [routerLink]="['/product', line.slug]" (click)="close()">
                <img [src]="line.imageUrl" [alt]="line.name" width="80" height="80" />
                {{ line.name }}
              </a>
              <span class="quantity">
                {{ line.quantity }} &times;
                <span class="woocommerce-Price-amount amount">
                  <span class="woocommerce-Price-currencySymbol">$</span
                  >{{ line.unitPrice | number: '1.2-2' }}
                </span>
              </span>
              <div class="quantity-row">
                <button type="button" class="minus" (click)="decrement(line)">−</button>
                <span>{{ line.quantity }}</span>
                <button type="button" class="plus" (click)="increment(line)">+</button>
              </div>
            </li>
          }
        </ul>
        <p class="woocommerce-mini-cart__total total">
          <strong>Subtotal:</strong>
          <span class="woocommerce-Price-amount amount">
            <span class="woocommerce-Price-currencySymbol">$</span
            >{{ cart.subtotal() | number: '1.2-2' }}
          </span>
        </p>
        <p class="woocommerce-mini-cart__total total">
          <strong>Tax ({{ cart.taxRatePercent() }}%):</strong>
          <span class="woocommerce-Price-amount amount">
            <span class="woocommerce-Price-currencySymbol">$</span
            >{{ cart.tax() | number: '1.2-2' }}
          </span>
        </p>
        <p class="woocommerce-mini-cart__total total">
          <strong>Total:</strong>
          <span class="woocommerce-Price-amount amount">
            <span class="woocommerce-Price-currencySymbol">$</span
            >{{ cart.total() | number: '1.2-2' }}
          </span>
        </p>
        <p class="woocommerce-mini-cart__buttons buttons">
          <a routerLink="/shop" class="button wc-forward" (click)="close()">Continue shopping</a>
          <a routerLink="/checkout" class="button checkout wc-forward" (click)="close()">Checkout</a>
        </p>
      }
    </div>
  </div>
</div>
